exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".goalDetail-13637ee8 span{margin-right:12px}.goalDetail-13637ee8 span:last-child{margin-right:0}\n", ""]);

// Exports
exports.locals = {
	"goalDetail": "goalDetail-13637ee8"
};